import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import Select, { SelectProps } from "@insite/mobius/Select";
import React, { useEffect } from "react";


export interface MakePickerProps {
    isEnabled?: boolean;
    makeFacet?: AttributeTypeFacetModel;
    selectedMake?: string;
    onMakeSelect: (make: string) => void;
}


export const MakePicker: React.FC<MakePickerProps> = ({
    isEnabled,
    makeFacet,
    selectedMake,
    onMakeSelect,
}) => {
    const [makes, setMakes] = React.useState<{ attributeValueId: string; value: string }[]>([]);

    useEffect(() => {
        if (makeFacet?.attributeValueFacets) {
            const sortedMakes = [...makeFacet.attributeValueFacets]
                .sort((a, b) => a.value.localeCompare(b.value));
            setMakes(sortedMakes);
        }
    }, [makeFacet]);

    const handleStateChange: SelectProps["onChange"] = event => {
        onMakeSelect(event.target.value);
    };

    return (
        <Select
            name="make"
            value={selectedMake}
            data-test-selector="ymm_make"
            onChange={handleStateChange}
            disabled={!isEnabled}
        >
            <option value="">{translate("Make")}</option>
            {makes.map((row) => (
                <option key={row.attributeValueId} value={row.attributeValueId}>
                    {row.value}
                </option>
            ))}
        </Select>
    );
};